module.exports = __webpack_public_path__ + "static/media/trash.c5e2d204.svg";